import { createAction, handleActions } from 'redux-actions'

const setFetching = createAction('SCREENS/SUBCONTRACTOR_VIEW/SUB_ORDERS/SET_FETCHING')
const resetFetching = createAction('SCREENS/SUBCONTRACTOR_VIEW/SUB_ORDERS/RESET_FETCHING')

const defaultState = false

const reducer = handleActions(
  {
    [setFetching]: (state, { payload }) => payload,
    [resetFetching]: () => defaultState,
  },
  defaultState,
)

export { setFetching, resetFetching, reducer }
